"use client"

import { type BooruPost } from "@/lib/booru-api"
import { Gem } from "@/lib/icons"
import { useTranslations } from "next-intl"
import type React from "react"

// Extracted from components/booru-detail-modal.tsx (pure move: same JSX, same behaviour).
interface PremiumContentAlertProps {
  hideUI: boolean
  post: BooruPost
  setShowPremiumModal: React.Dispatch<React.SetStateAction<boolean>>
}

export function PremiumContentAlert({
  hideUI,
  post,
  setShowPremiumModal,
}: PremiumContentAlertProps) {
  const tt = useTranslations("booruDetailModal")
  return (
    <>
      {!hideUI && post.site === 'doujins' && (post.isPremium || post.albumMediaCount === 1 || (post.albumImages && post.albumImages.length === 1)) && (
                <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[90%] max-w-md z-20 pointer-events-auto">
                  <div 
                    className="bg-gradient-to-r from-yellow-500/95 to-amber-600/95 rounded-lg px-4 py-3 shadow-2xl border border-amber-400/50 cursor-pointer hover:from-yellow-400/95 hover:to-amber-500/95 transition-all"
                    onClick={(e) => {
                      e.stopPropagation()
                      setShowPremiumModal(true)
                    }}
                  >
                    <div className="flex items-start gap-3">
                      <div className="flex-shrink-0 mt-0.5">
                        <Gem className="h-6 w-6" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-white font-bold text-sm mb-1 flex items-center gap-2">
                          {tt("premiumContent")}
                          <span className="text-xs opacity-75">{tt("clickForInfo")}</span>
                        </h3>
                        <p className="text-white/90 text-xs leading-relaxed">
                          {tt("thisGalleryRequiresAPremiumSubscriptionOn")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
    </>
  )
}
